import React, { useEffect, useState } from 'react';
import { getAllGalleries } from '../../services/operations/GALLARYAPI';
import LightboxModal from '../LightboxModel';

const Gallarynav = () => {
    const [galleries, setGalleries] = useState([]);
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [currentImages, setCurrentImages] = useState([]);

    useEffect(() => {
        const fetchGalleries = async () => {
            try {
                const result = await getAllGalleries();
                if (result?.success) {
                    setGalleries(result.galleries || []);
                    const allImages = result.galleries.flatMap((gallery) => gallery.images);
                    const imageUrls = allImages.map((image) => image.url);
                    setCurrentImages(imageUrls);
                } else {
                    console.error('Failed to fetch galleries');
                }
            } catch (error) {
                console.error('Error fetching galleries:', error);
            }
        };

        fetchGalleries();
    }, []);

    const openLightbox = (index) => {
        setCurrentImageIndex(index);
        setLightboxOpen(true);
    };

    const closeLightbox = () => setLightboxOpen(false);

    const nextImage = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex < currentImages.length - 1 ? prevIndex + 1 : prevIndex
        );
    };

    const previousImage = () => {
        setCurrentImageIndex((prevIndex) =>
            prevIndex > 0 ? prevIndex - 1 : prevIndex
        );
    };

    const allImagesWithTitles = galleries.flatMap((gallery) =>
        gallery.images.map((image) => ({
            ...image,
            galleryTitle: gallery.title,
        }))
    );

    return (
        <section className="bg-gray-100 py-12 overflow-hidden">
            <div className="container mx-auto px-4">
                <h2 className="text-3xl font-bold text-center font-roboto mb-8 text-[#D3B21C] underline">
                    Our Stunning Galleries
                </h2>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    {allImagesWithTitles.length > 0 ? (
                        allImagesWithTitles.map((image, index) => (
                            <div
                                key={image.public_id}
                                className="relative bg-white p-4 shadow-lg rounded-lg overflow-hidden group cursor-pointer"
                                onClick={() => openLightbox(index)}
                            >
                                <img
                                    src={image.url}
                                    alt={image.galleryTitle}
                                    className="w-full h-[20rem] object-cover rounded-lg transition-transform transform group-hover:scale-105"
                                />
                                <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                    <span className="text-white text-lg font-semibold">
                                        {image.galleryTitle}
                                    </span>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="col-span-full text-center text-lg">No galleries available</p>
                    )}
                </div>
            </div>

            {/* Lightbox Modal */}
            {lightboxOpen && currentImages.length > 0 && (
                <LightboxModal
                    image={currentImages[currentImageIndex]}
                    onClose={closeLightbox}
                    onNext={nextImage}
                    onPrevious={previousImage}
                    hasNext={currentImageIndex < currentImages.length - 1}
                    hasPrevious={currentImageIndex > 0}
                />
            )}
        </section>
    );
};

export default Gallarynav;
